export default "__VITE_ASSET__DH1BwC6V__"